import React from 'react';
import T from 'prop-types';

import TruncatedItems from './TruncatedItems';
import Button from '../../../../Buttons/Button';
import { getActiveOption } from '../../../../DateRangePicker/configs/predefined-ranges';
import { format } from '../../../../../utils/date';
import {
  baseDataPointsOptions,
  csvOnlyBaseDataPointsOptions,
  advancedDataPointsOptions,
} from '../../../configs/report';

const FREQUENCY_DESCRIPTIONS = {
  weekly: 'Weekly (runs on Monday with data through Sunday of previous week)',
  monthly: 'Monthly (first day of month with data through last day of previous month)',
  quarterly:
    'Quarterly (first day of calendar quarter with data through last day of previous calendar quarter)',
};

const getDataPointLabels = (report) => {
  if (report.data_type === 'mpi') return ['MPI'];

  const options =
    report.data_type === 'advanced'
      ? advancedDataPointsOptions(report.panel_version)
      : baseDataPointsOptions.concat(csvOnlyBaseDataPointsOptions);

  const labels = options.reduce(
    (acc, option) => ({
      ...acc,
      [option.value]: option.text,
    }),
    {}
  );
  return (report.data_points || []).map((value) => labels[value] || value);
};

const ConfirmationModalContent = ({ isProcessing, setStep, report, onConfirm }) => {
  const active = getActiveOption(
    format(report.start_date),
    format(report.end_date),
    format(report.end_date)
  );

  return (
    <>
      <div className="schedule-export-modal__content">
        <div className="schedule-export-modal__summary">
          <h3 className="schedule-export-modal__summary-title">{report.name}</h3>
          <div className="schedule-export-modal__summary-grid">
            <div className="text-bold">Date Range</div>
            {active.value === 'custom' ? (
              <div>
                {format(report.start_date)} – {format(report.end_date)}
              </div>
            ) : (
              <div>
                {active.label} ({format(report.start_date)} – {format(report.end_date)})
              </div>
            )}

            <div className="text-bold">Entities Metrics</div>
            <div>
              <TruncatedItems items={(report.entities || []).map((entity) => entity.value)} />
            </div>

            <div className="text-bold">Data Points</div>
            <div>
              <TruncatedItems items={getDataPointLabels(report)} />
            </div>

            <div className="text-bold">Schedule</div>
            <div>{FREQUENCY_DESCRIPTIONS[report.frequency] || report.frequency}</div>

            <div className="text-bold">Raw Data Granularity</div>
            <div className="text-capitalize">{report.data_granularity}</div>

            <div className="text-bold">Layout</div>
            <div>{report.output_format === 'horizontal' ? 'Columns' : 'Rows'}</div>

            <div className="text-bold">Export Type</div>
            <div className="text-uppercase">{report.export_type}</div>

            <div className="text-bold">Recipients</div>
            <div>
              {report.recipients?.length ? report.recipients.map((r) => r.value).join(', ') : '-'}
            </div>
          </div>
        </div>
      </div>
      <div className="schedule-export-modal__footer">
        <Button variant="secondary" size="lg" onClick={() => setStep('form')}>
          Back
        </Button>
        <Button size="lg" loading={isProcessing} disabled={isProcessing} onClick={onConfirm}>
          {report.id ? 'Schedule Export' : 'Schedule & Run Export'}
        </Button>
      </div>
    </>
  );
};

ConfirmationModalContent.propTypes = {
  isProcessing: T.bool.isRequired,
  setStep: T.func.isRequired,
  report: T.object.isRequired,
  onConfirm: T.func.isRequired,
};

export default ConfirmationModalContent;
